import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';

import { ReservationService } from '../reservation.service';
import { ReservationSummaryStoreService } from './services/reservation-summary-store.service';
import { Reservation } from '../reservation.model';
import { TableName } from '../../common/enums/TableName';
import { NoteStore } from '../../note/note-store.service';
import { Note } from '../../note/note.model';

@Component({
	selector: 'app-reservation-summary',
	templateUrl: './reservation-summary.component.html',
	styleUrls: ['./reservation-summary.component.scss'],
})
export class ReservationSummaryComponent implements OnInit, OnDestroy {
	constructor(
		private readonly _service: ReservationService,
		private readonly store: ReservationSummaryStoreService,
		private readonly noteService: NoteStore,
	) {}
	notesPanelOpenState = true;
	paymentsEditState = false;
	tasksPanelOpenState = false;
	subscription: Subscription;
	reservation: Reservation;
	reservationID = signal<number>(null);

	ngOnInit() {
		const { reservation } = this.store.getters();
		this._service.loadOrganizations('25');
		this._service.loadUsers();

		this.subscription = reservation().subscribe((val) => {
			this.reservation = val;
			this.reservationID.set(val.id);
		});
	}

	ngOnDestroy() {
		this.subscription?.unsubscribe();
	}

	get servicesSum() {
		return this.reservation.services.reduce((basePrice, currentService) => {
			return basePrice + currentService.price;
		}, 0);
	}

	resizePayments(resizeState: boolean) {
		this.paymentsEditState = resizeState;
	}

	protected readonly TableName = TableName;
}
